<li class="list-group-item list-group-item-action justify-content-between border-left-0 border-right-0 border-top-0" role="button" [ngClass]="{'bg-faded': visible}" (click)="toggle()">
    <span class="mb-0">
        Published date: <strong>{{auditItem.datePublished | date: 'd MMMM y HH:mm'}}</strong>@if (isFirst) {
        (Current)
        }
    </span>
    <span class="fa" [ngClass]="{'fa-angle-right': !visible, 'fa-angle-down': visible}"></span>
</li>

<div class="p-3" [hidden]="!visible">
    <div class="row">
        <div class="col">
            <span [innerHtml]="auditItem.text"></span>
            @if (auditItem.metaData.length > 0) {
            <div class="text-muted">
                <small>
                    <strong>Source:</strong>
                    @for (metadataItem of auditItem.metaData; track metadataItem; let i = $index) {
                    <span>
                        @if (metadataItem.url) {
                        <a href="{{metadataItem.url}}" title="{{metadataItem.url}}" target="_blank">{{metadataItem.name}}</a>
                        }
                        @if (!metadataItem.url) {
                        {{metadataItem.name}}
                        }
                    </span>
                    - {{metadataItem.value}}.
                    }
                </small>
            </div>
            }
        </div>
    </div>
</div>
